import {Skeleton} from "./skeleton";

const PageSkeleton = () => {
  return <Skeleton className="h-[98%] w-[98%] m-2" />;
};

export default PageSkeleton;
